import axios from 'axios';
import { env } from '@diana/env-ui';


const api = axios.create({
  baseURL: env('CLOUD_API_ENDPOINT') || 'https://hub.test.adpclear.io',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json, text/plain, */*',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // TODO: Check this later
      // localStorage.removeItem('access_token');
    }
    return Promise.reject(error);
  }
);

export default api; 